import React from 'react';
import { connect } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroller';
import { formValueSelector, arrayRemove, arrayPush } from 'redux-form';
import { assignToIngredientGetIngredientsRequest } from 'actions/ingredients/category';
import styles from './style.css';

class Ingredients extends React.Component {
  render() {
    const { ingredients } = this.props;
    return (
      <div className={styles.wrapper}>
        <InfiniteScroll
          pageStart={1}
          loadMore={this._onReachBottom}
          hasMore={this._hasMore()}
          useWindow={false}
          threshold={10}
          initialLoad={false}
        >
          {ingredients.map(ingredient => (
            <div className={`row ${styles['row-wrapper']}`} key={ingredient.id}>
              <div className={`col-sm-2 ${styles['ingredient-image-wrapper']}`}>
                <img src={ingredient.image.url} className={styles.image} />
              </div>
              <div className={`col-sm-9 ${styles['ingredient-name-wrapper']}`}>
                <p>{ingredient.name}</p>
              </div>
              <div
                className={`col-sm-1 pull-right ${styles['padding-checkbox']}`}
              >
                <input
                  type="checkbox"
                  checked={this._checked(ingredient.id)}
                  onChange={event =>
                    this._onChangeCheckbox(event, ingredient.id)
                  }
                />
              </div>
            </div>
          ))}
        </InfiniteScroll>
      </div>
    );
  }

  _hasMore = () => {
    const { currentPage, totalPage } = this.props;
    return currentPage < totalPage;
  };

  _onReachBottom = () => {
    const {
      currentPage,
      totalPage,
      assignToIngredients: { keyword },
      ingredients,
      dispatch,
    } = this.props;
    if (currentPage < totalPage) {
      dispatch(
        assignToIngredientGetIngredientsRequest(
          { keyword, page: currentPage + 1, with_batch: true },
          ingredients
        )
      );
    }
  };

  _onChangeCheckbox = (event, id) => {
    const {
      assignToIngredients: { ingredientIds },
      dispatch,
    } = this.props;
    let idxPosition = -1;
    if (ingredientIds) {
      ingredientIds.forEach((ingredientId, index) => {
        if (parseInt(ingredientId) === id) {
          idxPosition = index;
        }
      });
    }
    if (event.target.checked) {
      dispatch(arrayPush('assignToIngredient', 'ingredientIds', id));
    } else if (idxPosition !== -1) {
      dispatch(arrayRemove('assignToIngredient', 'ingredientIds', idxPosition));
    }
  };

  _checked = id => {
    const {
      assignToIngredients: { ingredientIds },
    } = this.props;
    let checked = false;
    if (ingredientIds) {
      ingredientIds.forEach(ingredientId => {
        checked = checked || parseInt(id) === ingredientId;
      });
    }
    return checked;
  };
}

const selector = formValueSelector('assignToIngredient');

function mapStateToProps(state) {
  const {
    assignToIngredients: { ingredients, currentPage, totalPage },
  } = state.ingredients.category;
  return {
    assignToIngredients: {
      ingredientIds: selector(state, 'ingredientIds'),
      keyword: selector(state, 'keyword'),
    },
    ingredients,
    currentPage,
    totalPage,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Ingredients);
